import MissionsDsfr from "components/templates/missionsDsfr/MissionsDsfr";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "MISSIONSDSFR",
  label: "Missions (DSFR)",
  Component: MissionsDsfr,
  initialContents: [
    {
      key: "missionsTitle",
      type: elementsTypes.EDITABLE_INPUT,
      value: "Parcourez nos missions",
    },
    {
      key: "missions",
      type: elementsTypes.DSFR_CARDS_LIST,
      value: "",
    },
    {
      key: "dynamicPart",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
  ],
};
